window.scroll_to_element = function() {
    var self = this;
    var $html_body = $('html, body');
    var $sticky_nav = $('.js-sticky-nav');

    /**
     * Scroll to element
     *
     * @author Bas Lokerman <bas@click.nl>
     * @param {string} class_name
     * @return void
     */
    self.init = function(class_name) {
        var $target = $(class_name);
        // Scroll to target element minus the height of the sticky navigation
        var current_scroll_position = document.documentElement.scrollTop;
        var stick_nav_height = $sticky_nav.height();

        $html_body.animate({
            scrollTop: $target.offset().top - stick_nav_height
        }, 1000);
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/scroll-to-element.js